import React, { useRef } from 'react';
import { Swiper as SwiperModule, SwiperSlide } from 'swiper/react';
import { FreeMode, Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/free-mode';
import { createDataLayerString } from '../../helpers/helpers';
import { BREAKPOINTS } from '../../helpers/breakpoints';

type ImageSwiperProps = {
  images: {
    media_url: string;
    alt_text: string;
  }[];
  nextLabel: string;
  prevLabel: string;
  productHeading: string;
  fullScreen?: boolean;
};

export const ImageSwiper = ({
  images,
  nextLabel,
  prevLabel,
  productHeading,
  fullScreen
}: ImageSwiperProps) => {
  const nextButton = useRef(null);
  const backButton = useRef(null);

  return (
    <div className="shingle-detail-masthead__image">
      <SwiperModule
        breakpoints={{
          768: {
            spaceBetween: 30,
            slidesPerView: fullScreen ? 1 : 1.2,
            centeredSlides: false
          }
        }}
        slidesPerView={(images.length > 0 && !fullScreen) ? 1.1 : 1}
        centeredSlides={true}
        spaceBetween={10}
        navigation={{
          nextEl: nextButton.current,
          prevEl: backButton.current
        }}
        modules={[FreeMode, Navigation]}
      >
        {images.map((image, index) => (
          <SwiperSlide key={index}>
            <picture>
              <source srcSet={`${image.media_url}?width=1328`} media={`(min-width: ${BREAKPOINTS.wide - 1}px)`} />
              <source srcSet={`${image.media_url}?width=1060`} media={`(min-width: ${BREAKPOINTS.desktop - 1}px)`} />
              <source srcSet={`${image.media_url}?width=994`} media={`(min-width: ${BREAKPOINTS.tabletLandscape - 1}px)`} />
              <source srcSet={`${image.media_url}?width=780`} media={`(min-width: ${BREAKPOINTS.tablet - 1}px)`} />
              <img
                src={`${image.media_url}?width=660`}
                alt={image.alt_text}
                width="290"
                height="180"
                data-layer={createDataLayerString([
                  {
                    event: 'product_click',
                    event_category: 'product',
                    event_action: 'gallery',
                    event_label: 'thumbnail',
                    event_attributes: {
                      product_name: productHeading,
                      product_category: 'Shingle'
                    }
                  }
                ])}
              />
            </picture>
          </SwiperSlide>
        ))}
      </SwiperModule>
      <button
        ref={backButton}
        className="swiper-button-prev"
        aria-label={prevLabel || 'previous slide'}
        title={prevLabel || 'previous slide'}
        data-layer={createDataLayerString([
          {
            event: 'product_click',
            event_category: 'product',
            event_action: 'gallery',
            event_label: 'previous arrow',
            event_attributes: {
              product_name: productHeading,
              product_category: 'Shingle'
            }
          }
        ])}
      ></button>

      <button
        ref={nextButton}
        className="swiper-button-next"
        aria-label={nextLabel || 'next slide'}
        title={nextLabel || 'next slide'}
        data-layer={createDataLayerString([
          {
            event: 'product_click',
            event_category: 'product',
            event_action: 'gallery',
            event_label: 'next arrow',
            event_attributes: {
              product_name: productHeading,
              product_category: 'Shingle'
            }
          }
        ])}
      ></button>
    </div>
  );
};

export default ImageSwiper;
